import { render } from "./Estudios.vue?vue&type=template&id=10ab4438"
import script from "./Estudios.vue?vue&type=script&lang=js"
export * from "./Estudios.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__